import React, { useState } from "react";
import {
  Flex,
  Box,
  Input,
  Text,
  Select,
  Heading,
  Stat,
  StatNumber,
  StatHelpText,
} from "@chakra-ui/react";

const VINDetailsFinderPage = (): JSX.Element => {
  const years: { [key: string]: string } = {
    A: "2010",
    B: "2011",
    C: "2012",
    D: "2013",
    E: "2014",
    F: "2015",
    G: "2016",
    H: "2017",
    J: "2018",
    K: "2019",
    L: "2020",
    M: "2021",
    N: "2022",
    P: "2023",
    R: "2024",
    S: "2025",
    T: "2026",
    U: "2027",
    V: "2028",
    W: "2029",
    X: "2030",
  };

  const months: { [key: string]: string } = {
    A: "January",
    B: "February",
    C: "March",
    D: "April",
    E: "May",
    F: "June",
    G: "July",
    H: "August",
    J: "September",
    K: "October",
    L: "November",
    M: "December",
  };
  const [vin, setVin] = useState<Array<string>>([]); //MA3RYHL1SSC577818

  return (
    <Flex
      width={"full"}
      minHeight={"calc(100vh - 100px)"}
      justifyContent={"center"}
      alignItems={"center"}
      direction={"column"}
      gap={12}
    >
      <Heading size={"lg"}>VIN details finder</Heading>

      <Flex
        width={{ base: "100%", md: "50%" }}
        direction={{ base: "column", md: "row" }}
        gap={12}
      >
        <Flex width={{ base: "100%", md: "50%" }} direction={"column"}>
          <Text>Manufacturer</Text>
          <Select marginTop={1}>
            <option value="marutiSuzuki">Maruti Suzuki</option>
          </Select>

          <Text marginTop={6}>VIN</Text>
          <Input
            marginTop={1}
            type={"text"}
            placeholder={"Type VIN here"}
            minLength={17}
            maxLength={17}
            value={vin.join("")}
            onChange={(event) => setVin(event.target.value.split(""))}
          />
        </Flex>

        <Flex
          width={{ base: "100%", md: "50%" }}
          direction={"column"}
          justifyContent={"space-between"}
          alignItems={{ base: "start", md: "end" }}
          gap={12}
        >
          <Box>
            <Text>Manufacturing year</Text>
            <Flex
              marginTop={1}
              justifyContent={{ base: "start", md: "end" }}
              alignItems={"center"}
              gap={3}
              fontWeight={"bold"}
            >
              <Text paddingX={1} border={"1px solid"}>
                {vin[9]}
              </Text>
              <Text>{years[vin[9]]}</Text>
            </Flex>
          </Box>

          <Box>
            <Text>Manufacturing month</Text>
            <Flex
              marginTop={1}
              justifyContent={{ base: "start", md: "end" }}
              alignItems={"center"}
              gap={3}
              fontWeight={"bold"}
            >
              <Text paddingX={1} border={"1px solid"}>
                {vin[10]}
              </Text>
              <Text>{months[vin[10]]}</Text>
            </Flex>
          </Box>
        </Flex>
      </Flex>

      <Flex gap={3} wrap={"wrap"}>
        {vin.map((character, index) => (
          <Stat key={index} textAlign={"center"}>
            <StatNumber
              paddingX={1}
              border={index === 9 || index === 10 ? "1px solid" : ""}
            >
              {character}
            </StatNumber>
            <StatHelpText>{index + 1}</StatHelpText>
          </Stat>
        ))}
      </Flex>
    </Flex>
  );
};

export default VINDetailsFinderPage;
